module.exports = __webpack_public_path__ + "static/media/summer secretary.f1abd684.jpg";